/**
 * Postcard form field
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-17 17:04:51
 */

// types
import type {FieldInfo, HandleFields} from '~/types/field.types';

export interface SnapPackMailerFields extends HandleFields {
  postage_type: string;
}

export type SnapPackMailerField = keyof SnapPackMailerFields;

const fields: FieldInfo<SnapPackMailerField>[] = [
  {
    label: 'Select Template',
    placeholder: 'Choose...',
    key: 'select_template',
    type: 'list',
    required: true,
    items: [],
    cast: v => Number(v)
  },
  {
    key: 'select_date',
    label: 'Schedule Date',
    placeholder: 'Choose...',
    type: 'list',
    required: true,
    items: [],
  },
  {
    key: 'specific_date',
    label: 'Specific Date',
    placeholder: 'Select...',
    type: 'text',
    required: true,
  },
  {
    key: 'offer_percentage',
    label: 'Offer Percentage',
    placeholder: 'e.g., 30',
    helpText: '% of Estimated Property Value',
    type: 'numeric',
    defaultValue: '0',
    cast: v => Number(v),
  },
  {
    key: 'first_name',
    type: 'text',
    label: 'To First Name',
    placeholder: 'e.g, John',
    category: 'receiver',
  },
  {
    key: 'last_name',
    type: 'text',
    label: 'To Last Name',
    placeholder: 'e.g, Doe',
    category: 'receiver',
  },
  {
    key: 'company_name',
    type: 'text',
    label: 'To Company Name',
    placeholder: 'e.g, Solution Inc.',
    category: 'receiver',
  },
  {
    key: 'address_1',
    type: 'text',
    label: 'To Address Line 1',
    placeholder: 'e.g., 123 Main St',
    category: 'receiver',
  },
  {
    key: 'address_2',
    type: 'text',
    label: 'To Address Line 2',
    placeholder: 'e.g., Near south station',
    category: 'receiver',
  },
  {
    key: 'city',
    type: 'text',
    label: 'To City',
    placeholder: 'e.g, New York',
    required: true,
    category: 'receiver',
  },
  {
    key: 'state',
    type: 'text',
    label: 'To State',
    placeholder: 'e.g, New York',
    required: true,
    category: 'receiver',
  },
  {
    key: 'zip',
    type: 'text',
    label: 'To Zip Code',
    placeholder: 'e.g, 07008',
    required: true,
    category: 'receiver',
  },
  {
    key: 'zip',
    type: 'text',
    label: 'To Zip Code',
    placeholder: 'e.g, 07008',
    required: true,
    category: 'receiver',
  },
  {
    key: 'phone_no',
    type: 'text',
    label: 'Phone Number',
    placeholder: 'e.g, 15454545454',
    required: false,
    category: 'receiver',
  },
  {
    key: 'email',
    type: 'text',
    label: 'Email address',
    placeholder: 'e.g, user@domain.com',
    required: false,
    category: 'receiver',
  },
  {
    label: 'Property Address',
    key: 'property_address',
    placeholder: 'e.g., 123 Main St',
    type: 'text',
    category: 'propertyAddress',
  },
  {
    label: 'Property City',
    placeholder: 'e.g, New York',
    key: 'property_city',
    type: 'text',
    category: 'propertyAddress',
  },
  {
    label: 'Property State',
    placeholder: 'e.g, New York',
    key: 'property_state',
    type: 'text',
    category: 'propertyAddress',
  },
  {
    label: 'Property Zip Code',
    placeholder: 'e.g, 07008',
    key: 'property_zip_code',
    type: 'text',
    category: 'propertyAddress',
  },

  // From fields
  {
    label: 'From Name',
    placeholder: 'e.g, John Doe',
    key: 'from_name',
    type: 'text',
    category: 'sender',
  },
  {
    label: 'From Company Name',
    placeholder: 'e.g, Solution Inc.',
    key: 'from_company',
    type: 'text',
    category: 'sender',
  },
  {
    label: 'From Address Line 1',
    key: 'from_address_1',
    placeholder: 'e.g., 123 Main St',
    type: 'text',
    category: 'sender',
  },
  {
    key: 'from_address_2',
    type: 'text',
    label: 'From Address Line 2',
    placeholder: 'e.g., Near south station',
    category: 'sender',
  },
  {
    key: 'from_city',
    type: 'text',
    label: 'From City',
    placeholder: 'e.g, New York',
    category: 'sender',
  },
  {
    key: 'from_state',
    type: 'text',
    label: 'From State',
    placeholder: 'e.g, New York',
    category: 'sender',
  },
  {
    key: 'from_zip',
    type: 'text',
    placeholder: 'e.g, 07008',
    label: 'From Zip Code',
    category: 'sender',
  },
];

export {fields};
